import CrossSVG from '@public/icons/cross.svg';
import classNames from 'classnames';
import { Dispatch, SetStateAction } from 'react';
import RoundButton from '@/shared/components/shared/RoundButton';
import { useDebounce } from '@/shared/hooks/use-debounce';
import { tp } from '@/shared/lib/typograf';

type Props = {
    data: { message: string; messageSecondary?: string } | null;
    setData: Dispatch<SetStateAction<{ message: string; messageSecondary?: string } | null>>;
};

const FormResponse = ({ data, setData }: Props) => {
    const debouncedData = useDebounce(data, 500);
    const dataSource = data || debouncedData;

    return (
        <div className={classNames('form-response', { 'is-visible': !!data })}>
            <RoundButton
                variant="primary"
                aria-label="Закрыть"
                onClick={() => {
                    setData(null);
                }}
                className="form-response__close-btn"
            >
                <CrossSVG />
            </RoundButton>
            <div className="form-response-content">
                {dataSource?.message && (
                    <div
                        className="h3 form-response-content__title"
                        dangerouslySetInnerHTML={{ __html: tp(dataSource.message) }}
                    ></div>
                )}
                {dataSource?.messageSecondary && (
                    <div
                        className="text-l form-response-content__text"
                        dangerouslySetInnerHTML={{ __html: tp(dataSource.messageSecondary) }}
                    ></div>
                )}
            </div>
        </div>
    );
};

export default FormResponse;
